<template>
    <v-footer class="res_wrap py-6 py-md-10 px-2 text-caption grey--text text--darken-2 grey lighten-2" padless>

      <v-row justify="center" no-gutters>
        <!-- <v-col cols="12" md="5" order-md="2" class="text-center text-md-right pb-6">
          <v-btn outlined plain small width="10rem" class="text-capitalize mr-1">
            Company Brochure
          </v-btn>

          <v-btn outlined plain small width="10rem" class="text-capitalize" href="/contactus">
            Contact Us
          </v-btn>
        </v-col> -->

        <v-col cols="12" order-md="1" class="text-center">
          <v-img alt="Jeinsoft Logo" class="mx-auto mb-4" contain src="@/assets/logo_bottom.svg" position="center center" transition="scale-transition" width="9.4375rem" height="1.375rem" />

          <v-row no-gutters>
            <v-col cols="12">사업자등록번호 : 129-86-64916</v-col>
            <v-col cols="12">본사 : (16942) 경기도 용인시 수지구 광교중앙로 338 (상현동, 광교우미뉴브 B동 310호)</v-col>
            <!-- <v-col cols="12">지사 : (07299) 서울특별시 영등포구 경인로 775 에이스하이테크시티(문래동3가, 1동 707-1호)</v-col> -->
<!--            <v-col cols="12">지사 : (06729) 서울 서초구 효령로 424 대명빌딩 301호</v-col>-->
            <v-col cols="12" class="pt-3 grey--text text--darken-1 font-weight-light">© {{ new Date().getFullYear() }} JeinSoft. All rights reserved.</v-col>
          </v-row>

        </v-col>



      </v-row>
    </v-footer>
</template>

<script>
  export default {
    name: 'main-footer',
    data () {
      return {
        title: void 0
      }
    },
    methods: {
      showTitle () {
        this.title = 'The main footer'
      }
    }
  }
</script>
